import { QUESTION_TYPE } from "@/consts/survey";

export const JUMP_LOGIC_PATHS = {
  DETRACTOR: "detractor",
  PASSIVE: "passive",
  PROMOTER: "promoter"
};

export const JUMP_ACTIONS = {
  NEXT_QUESTION: 1,
  SPECIFIC_QUESTION: 2,
  FINISH_SURVEY: 3
};

export const NOT_QUESTIONS = [QUESTION_TYPE.LABEL, QUESTION_TYPE.IMAGE];

export const UNSUPPORTED_TYPES = [QUESTION_TYPE.OPEN, QUESTION_TYPE.RATINGS, QUESTION_TYPE.LABEL, QUESTION_TYPE.IMAGE];

export const JUMP_LOGIC_LABELS = {
  [QUESTION_TYPE.NPS_RELATIONAL]: {
    [JUMP_LOGIC_PATHS.DETRACTOR]: "survey.new.jump_logic.detractor",
    [JUMP_LOGIC_PATHS.PASSIVE]: "survey.new.jump_logic.passive",
    [JUMP_LOGIC_PATHS.PROMOTER]: "survey.new.jump_logic.promoter"
  },
  [QUESTION_TYPE.NPS_TRANSACTIONAL]: {
    [JUMP_LOGIC_PATHS.DETRACTOR]: "survey.new.jump_logic.detractor",
    [JUMP_LOGIC_PATHS.PASSIVE]: "survey.new.jump_logic.passive",
    [JUMP_LOGIC_PATHS.PROMOTER]: "survey.new.jump_logic.promoter"
  },
  [QUESTION_TYPE.CSAT]: {
    [JUMP_LOGIC_PATHS.DETRACTOR]: "survey.new.jump_logic.unsatisfied",
    [JUMP_LOGIC_PATHS.PASSIVE]: "survey.new.jump_logic.neuter",
    [JUMP_LOGIC_PATHS.PROMOTER]: "survey.new.jump_logic.satisfied"
  },
  [QUESTION_TYPE.EMOJI]: {
    [JUMP_LOGIC_PATHS.DETRACTOR]: "survey.new.jump_logic.unsatisfied",
    [JUMP_LOGIC_PATHS.PASSIVE]: "survey.new.jump_logic.neuter",
    [JUMP_LOGIC_PATHS.PROMOTER]: "survey.new.jump_logic.satisfied"
  },
  [QUESTION_TYPE.CES]: {
    [JUMP_LOGIC_PATHS.DETRACTOR]: "survey.new.jump_logic.hard",
    [JUMP_LOGIC_PATHS.PASSIVE]: "survey.new.jump_logic.neuter",
    [JUMP_LOGIC_PATHS.PROMOTER]: "survey.new.jump_logic.easy"
  },
  [QUESTION_TYPE.CES2]: {
    [JUMP_LOGIC_PATHS.DETRACTOR]: "survey.new.jump_logic.hard",
    [JUMP_LOGIC_PATHS.PASSIVE]: "survey.new.jump_logic.neuter",
    [JUMP_LOGIC_PATHS.PROMOTER]: "survey.new.jump_logic.easy"
  },
  [QUESTION_TYPE.THUMBS]: {
    [JUMP_LOGIC_PATHS.DETRACTOR]: "survey.new.jump_logic.dislike",
    [JUMP_LOGIC_PATHS.PROMOTER]: "survey.new.jump_logic.like"
  }
};
